"use strict";

var _defineProperty = require("/home/bacancy/Desktop/incidentgo/project/incident-code-web/node_modules/@babel/runtime/helpers/defineProperty");

var _violation_types;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("./types"); // todo: move resources that used cross in App, Api and wall to here.


exports.sharedStrings = {
  violation_types: (_violation_types = {}, _defineProperty(_violation_types, types_1.ViolationType.WrongContent, "Inappropriate content"), _defineProperty(_violation_types, types_1.ViolationType.NoContent, "No content in the video"), _defineProperty(_violation_types, types_1.ViolationType.Other, "Other"), _violation_types)
};